import React, { useState } from 'react';

const Nav = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        if (!isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    };

    return (
        <div className="nav" >
            <nav className="navbar">
                <div className="left">
                    <img src="/assets/Dr.Mostafa Logo 2.png" alt="Dr. Mostafa Logo" />
                </div>

                {/* Toggle Button */}
                <button className="toggle-button" onClick={toggleMenu}>
                    {isMenuOpen ? '✕' : '☰'}
                </button>

                {/* Menu */}
                <div className={`right ${isMenuOpen ? 'active' : ''}`} dir="rtl" lang="ar" >
                    <ul style={{direction:"rtl"}}>
                        <li className="main"><a href="#home" onClick={toggleMenu}>الرئيسيه</a></li>
                        <li><a href="#about" onClick={toggleMenu}>عن الدكتور</a></li>
                        <li><a href="#why" onClick={toggleMenu}>لماذا نحن..؟</a></li>
                        <li><a href="#opinion" onClick={toggleMenu}>شهادات المرضى</a></li>
                        <li><a href="#footer" onClick={toggleMenu}>أتصل بنا</a></li>




                    </ul>
                </div>
            </nav>

            <style jsx>{`
                .nav {
                overflow: hidden;

  background: linear-gradient(to right, #E035A9, #7A1D5C);
                    position: relative;
                }

                .nav .navbar {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin: 0 30px;
                }

                .nav .right {
                    display: flex;
                    align-items: center;
                    background-color: #7E0F4E;
                    border-radius: 25px;
                }

                .nav .navbar .right ul {
                    display: flex;
                    direction: ltr;
                    align-items: center;
                    font-weight: bold;
                }

                .nav .navbar .right ul li a {
                    font-family: "Hacen Tunisia";
                    text-decoration: none;
                    font-size: 23px;
                    text-align: center;
                    margin: 13px;
                    color: #ffffff;
                    list-style: none;
                    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
                }

                .nav .navbar .right ul li {
                    list-style: none;
                }

                .nav .navbar .right ul .main a {
                    color: #7E0F4E;
                    background-color: #ffffff;
                    border-radius: 5px;
                    padding: 5px;
                }

                .nav .navbar .right ul li a:hover {
                    cursor: pointer;
                    background-color: #ffffff;
                    color: #7E0F4E;
                    transition: all 0.3s ease;
                }

                .nav .toggle-button {
                    display: none;
                    font-size: 24px;
                    color: #ffffff;
                    background: none;
                    border: none;
                    background-color: #7E0F4E;
                    cursor: pointer;
                    z-index: 1000;
                }

                @media screen and (max-width: 768px) {
                  

                    .nav .toggle-button {
                        display: block;
                    }

                    .nav .right {
                        display: none;
                        width: 100vw;
                        height: 100vh;
                        position: fixed;
                        top: 0;
                        left: 0;
                        background-color: #7E0F4E;
                        padding: 0;
                        margin: 0;
                        border-radius: 0;
                        z-index: 998;
                          direction: rtl;


                    }

                    .nav .right.active {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                                                  direction: rtl;

                    }

                    .nav .navbar .right ul {
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        height: 100%;
                        padding: 0;
                                                  direction: rtl;

                    }

                    .nav .navbar .right ul li {
                        margin: 20px 0;
                        opacity: 0;
                        animation: fadeIn 0.5s ease forwards;
                    }

                    .nav .navbar .right ul li:nth-child(1) { animation-delay: 0.2s; }
                    .nav .navbar .right ul li:nth-child(2) { animation-delay: 0.3s; }
                    .nav .navbar .right ul li:nth-child(3) { animation-delay: 0.4s; }
                    .nav .navbar .right ul li:nth-child(4) { animation-delay: 0.5s; }
                    .nav .navbar .right ul li:nth-child(5) { animation-delay: 0.6s; }

                    .nav .navbar .right ul li a {
                        font-size: 28px;
                        margin: 15px;
                    }

                    .nav .navbar {
                        margin: 0 15px;
                        padding: 15px 0;
                    }

                    @keyframes fadeIn {
                        from {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                }
            `}</style>
        </div>
    );
};

export default Nav;